module.exports = __webpack_public_path__ + "static/media/kremales.9a0e660d.jpg";